/* v6写法 */
import { lazy, Suspense } from "react"; //懒加载
import { UnorderedListOutlined, SettingOutlined, createFromIconfontCN } from "@ant-design/icons";
import Fallback from "../components/fallback";
import { Navigate } from "react-router-dom";
import React from "react";

const IconFont = createFromIconfontCN({
	scriptUrl: ["//at.alicdn.com/t/c/font_4582764_waczj9gqwcg.js"]
});

const routes = [
	{
		path: "/*",
		element: <Navigate to="/login" />
	},
	{
		path: "/login",
		element: () => import("../pages/login"),
		meta: { title: "登录" }
	},
	{
		path: "/",
		element: () => import("../components/layout/index"),
		meta: { title: "layout" },
		redirect: "/home",
		children: [
			{
				path: "/home",
				element: () => import("../pages/home/index"),
				meta: {
					title: "首页",
					icon: <IconFont type="icon-sidebar_icon_home_pre" />
				}
			},
			{
				path: "/financialManagement",
				meta: {
					title: "财务管理",
					icon: <IconFont type="icon-sidebar_icon_finance" />
				},
				children: [
					{
						path: "/financialManagement/balance",
						element: () => import("../pages/financial/balance/index"),
						meta: { title: "我的余额" }
					},
					{
						path: "/financialManagement/account",
						element: () => import("../pages/financial/account/index"),
						meta: { title: "账户充值" }
					}
				]
			},
			{
				path: "/apiRecharge",
				meta: { title: "API充值", icon: <IconFont type="icon-sidebar_icon_api" /> },
				children: [
					{
						path: "/apiRecharge/product-management",
						element: () => import("../pages/apiRecharge/product-management"),
						meta: { title: "商品管理" }
					},
					{
						path: "/apiRecharge/order-list",
						element: () => import("../pages/apiRecharge/order-list"),
						meta: { title: "订单列表" }
					},
					{
						path: "/apiRecharge/recharge-orders",
						element: () => import("../pages/apiRecharge/recharge-orders"),
						meta: { title: "批量充值订单" }
					},
					{
						path: "/apiRecharge/recharge-orders/detailed/:id",
						element: () => import("../pages/apiRecharge/recharge-orders/components/detailed"),
						meta: { title: "订单明细", hide: true }
					},
					{
						path: "/apiRecharge/recharge-orders/logs/:id",
						element: () => import("../pages/apiRecharge/recharge-orders/components/logs"),
						meta: { title: "批量充值日志", hide: true }
					},
					{
						path: "/apiRecharge/configPage",
						element: () => import("../pages/apiRecharge/configPage/index"),
						meta: { title: "应用配置" }
					}
				]
			},
			{
				path: "/purchasingManagement",
				meta: { title: "采购管理", icon: <IconFont type="icon-sidebar_icon_shop" /> },
				children: [
					{
						path: "/purchasingManagement/procurement-center",
						element: () => import("../pages/purchasing-management/procurement-center/index"),
						meta: { title: "采购中心" }
					},
					{
						path: "/purchasingManagement/procurement-center/select-goods/:param",
						element: () => import("../pages/purchasing-management/goods-item"),
						meta: { title: "选择采购商品", hide: true }
					},
					{
						path: "/purchasingManagement/procurement-center/sure-goods/:param",
						element: () => import("../pages/purchasing-management/confirm-order"),
						meta: { title: "确认采购商品", hide: true }
					},
					{
						path: "/purchasingManagement/shopping-cart",
						element: () => import("../pages/purchasing-management/shopping-cart/index"),
						meta: { title: "购物车" }
					},
					{
						path: "/purchasingManagement/shopping-cart/sure-goods/:param",
						element: () => import("../pages/purchasing-management/confirm-order"),
						meta: { title: "确认采购商品", hide: true }
					},
					{
						path: "/purchasingManagement/order-list",
						element: () => import("../pages/purchasing-management/order-list/index"),
						meta: { title: "订单列表" }
					},
					{
						path: "/purchasingManagement/order-list/order-detail/:param",
						element: () => import("../pages/purchasing-management/order-detail"),
						meta: { title: "订单详情", hide: true }
					}
				]
			}
		]
	},
	{
		path: "/error",
		element: () => import("../pages/error"),
		meta: { title: "error" }
	}
];

//包裹懒加载器
function LazyElement({ importFunc }) {
	const LazyComponent = lazy(importFunc);
	return (
		<Suspense fallback={<Fallback />}>
			<LazyComponent />
		</Suspense>
	);
}

// 处理routes 如果element是懒加载，要包裹Suspense
function dealRoutes(routesArr) {
	if (routesArr && Array.isArray(routesArr) && routesArr.length > 0) {
		routesArr.forEach((route) => {
			if (route.element && typeof route.element === "function") {
				const importFunc = route.element;
				route.element = <LazyElement importFunc={importFunc} />;
			}
			if (route.children) {
				dealRoutes(route.children);
			}
		});
	}
}
dealRoutes(routes);

/* *********** 扁平路由 ************ */
export function flatRouterFunction(route = routes, flatRouter = []) {
	route.map((r) => {
		if (r.children) {
			flatRouter.push({
				path: r.path,
				title: r.meta?.title || "layout",
				unTag: true,
				crumbs: r.meta?.crumbs
			});
			flatRouterFunction(r.children, flatRouter);
		} else {
			flatRouter.push({
				path: r.path,
				title: r.meta?.title,
				crumbs: r.meta?.crumbs
			});
		}
	});
	return flatRouter;
}

export default routes;
